var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.653 1.8c0 .97-.842 1.758-1.88 1.758-1.038 0-1.88-.787-1.88-1.758S1.736.042 2.774.042c1.038 0 1.88.787 1.88 1.758zM1.15 4.85h3.214v9.736H1.15V4.85zM9.537 4.85H6.324v9.736h3.213V9.604c0-1.15.392-2.305 1.96-2.305 1.77 0 1.76 1.505 1.752 2.671-.01 1.525.015 3.08.015 4.616h3.213V9.447c-.027-3.28-.882-4.793-3.695-4.793-1.67 0-2.706.759-3.245 1.445v-1.25z",
    fill: "#353844"
  })));
}
export default __webpack_public_path__ + "media/icons/linkedin-2-a89e2079.svg";
export { SvgLinkedin2 as ReactComponent };